
/**
 * This file is for adding custom methods to Cash
 * https://github.com/fabiospampinato/cash/blob/master/docs/extending_cash.md
 * 
 */

import $ from "cash-dom";
import { Cash } from 'cash-dom';

declare module 'cash-dom' {
  interface Cash {
    /**
     * Returns `True` if the collection is not empty
     */
    exists (): boolean
  }
}

$.fn.exists = function ( this: Cash ): boolean {
  return this.length !== 0;
}
global.$ = $;
